import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tag } from 'primereact/tag';
import useToast from "../../hooks/ToastHook";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const toast = useToast();
    const [ industries, setIndustries ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        setLoading(true);
        retrieve();
    }, [page, limit]);

    const retrieve = () => {
        api.get(`industries?page=${page}&limit=${limit}`).then(({ data }) => {
            setIndustries(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    const accept = (industry) => {
        setLoading(true);
        api.put(`industries/${industry.id}/relationship`, { status: 'ACTIVE' }).then(() => {
            toast.showSuccess('Conexão realizada com sucesso');
            retrieve();
        }).finally(() => {
            setLoading(false);
        });
    }

    const actions = industry => industry.status === 'WAITING' ? (
        <>
            <Button icon="pi pi-check" severity="success" title="Aceitar" onClick={() => accept(industry)}/>
            <Button className="ml-2" severity="danger" icon="pi pi-times" title="Negar" onClick={() => navigate('./' + industry.id)}/>
        </>
    ) : <></>;

    const statusColumnBody = (industry) => industry.status === 'WAITING'
        ? <Tag severity="warning" value="AGUARDANDO"/>
        : <Tag value="ATIVO"/>;

    return (
        <div>
            <PageTitle title="Indústrias" subtitle="Estabeleça conexões entre sua distribuidora e indústrias"/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={industries} selectionMode="single" emptyMessage="Nada encontrado">
                        <Column field="commercialName" header="Empresa"></Column>
                        <Column field="document" header="CPF/CNPJ"></Column>
                        <Column body={statusColumnBody} header="Status"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}